/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-10 17:40:19
 * @LastEditTime : 2020-04-18 14:59:02
 * @LastEditors  : you name
 */
export default {
    // API: 'http://192.168.2.24:9020',
    // API: 'http://192.168.1.48:9009'
    // API: 'http://data-center.xhj.com',

    // API: 'http://192.168.1.105:9000/api/datacenter',
    // EXTERNAL_API:'http://192.168.1.105:9000/api/auth'

    API: 'https://gateway.xhj.com/api/datacenter',
    EXTERNAL_API: 'https://gateway.xhj.com/api/auth'

}